import { render, staticRenderFns } from "./legendModal.vue?vue&type=template&id=ba542784&scoped=true&"
import script from "./legendModal.vue?vue&type=script&lang=js&"
export * from "./legendModal.vue?vue&type=script&lang=js&"
import style0 from "./legendModal.vue?vue&type=style&index=0&id=ba542784&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba542784",
  null
  
)

export default component.exports